// Previene el Bug 3: SQLSTATE[22P02] cuando id_device se envía como string.
// Ver references/api-contracts.md § Bugs.

export class IdDevice {
  private constructor(public readonly value: number) {}

  /** Acepta number o string numérico. Falla si recibe un string no-numérico (ej. UUID). */
  static from(input: number | string | null | undefined): IdDevice | null {
    if (input === null || input === undefined) return null;
    if (typeof input === 'number') {
      if (!Number.isInteger(input) || input < 0) {
        throw new Error(`IdDevice: número inválido ${input}`);
      }
      return new IdDevice(input);
    }
    const parsed = Number.parseInt(input, 10);
    if (Number.isNaN(parsed) || String(parsed) !== input.trim()) {
      throw new Error(`IdDevice: no es un entero válido: "${input}"`);
    }
    return new IdDevice(parsed);
  }

  toJSON(): number { return this.value; }
  toString(): string { return String(this.value); }
}
